<template>
  <div>
    <a
      @click="ShowModal"
      class="btn btn-sm btn-light-primary font-weight-bolder text-uppercase mr-2 btn-block"
      >ویرایش</a
    >
    <b-modal
      size="lg"
      :id="'edit-gateway-modal-' + gatewayId"
      title="ویرایش درگاه پرداخت"
      cancel-title="انصراف"
      ok-title="ذخیره"
      @ok.prevent="savePaymentGateway"
    >
      <form ref="newgateform">
        <div>
          <b-row>
            <div class="col-md-4">
              <b-form-group label="لوگو">
                <fileUploader
                  ref="upload_logo"
                  v-model="newgate.logo"
                ></fileUploader>
              </b-form-group>
              <b-img
                v-if="newgate.logo != null"
                :src="'http://api.shepa.com/api/file/' + newgate.logo"
                fluid
              ></b-img>
            </div>
            <div class="col-md-4">
              <b-form-group label="توضیحات">
                <b-form-textarea
                  v-model="newgate.description"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group label="نحوه واریز مبلغ">
                <MDDropdown
                  v-bind:group="104"
                  v-model="newgate.mdid104_payment_priority"
                  aria-describedby="input_mdid104_payment_priority_describe"
                ></MDDropdown>
                <b-form-invalid-feedback
                  id="input_mdid104_payment_priority_describe"
                  >نحوه واریز مبلغ را انتخاب کنید</b-form-invalid-feedback
                >
              </b-form-group>
              <b-form-group
                v-if="newgate.mdid104_payment_priority != 1658"
                label="در روز"
              >
                <MDDropdown
                  v-bind:group="105"
                  v-model="newgate.mdid105_payment_time"
                  v-bind:parent="newgate.mdid104_payment_priority"
                ></MDDropdown>
              </b-form-group>
              <b-form-group v-if="newgate.mdid12_money_type!=1722" label="نوع کارمزد:">
                <b-form-select
                  :options="purcentOptions"
                  v-model="newgate.purcent_from_merchant"
                ></b-form-select>
              </b-form-group>
            </div>
          </b-row>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
import httpHelper from "../../helpers/httpHelper";
import MDDropdown from "../../components/MDDropdown";
import FileUploader from "@/components/fileUploader";
export default {
  name: "EditGateway",
  props: ["gatewayId", "afterDone"],
  data() {
    return {
      newgate: {},
      purcentOptions:[
          { value: 0, text: "کسر از کاربر" },
          { value: 1, text: "کسر از پذیرنده" },
      ]
    };
  },
  components: {
    FileUploader,
    MDDropdown,
  },
  methods: {
    ShowModal() {
      httpHelper.setAuth();
      httpHelper
        .getData("paymentgateways?id=" + this.gatewayId)
        .then((response) => {
          this.newgate = response.result[0];
          this.$bvModal.show("edit-gateway-modal-" + this.gatewayId);
        })
        .finally(() => {});
    },
    savePaymentGateway() {
      httpHelper.postData("paymentgateways", this.newgate).then((res) => {
        this.$bvModal.hide("edit-gateway-modal-" + this.gatewayId);
        if (this.afterDone) {
          this.afterDone();
        }
      });
    },
  },
};
</script>